module.exports = __webpack_public_path__ + "img/icon-building-color.ecf2357a.png";